import { PAQUETES_MARCA } from './brand-packs';
import { UiConfig } from './ui-config.model';

const CONSIGLIA = PAQUETES_MARCA.consiglia;

/**
 * Configuración compilada: la edición Consiglia vestida con su paquete de marca.
 * Es el último recurso de la cascada (localStorage -> `/public/ui-config` -> esto).
 * El relleno campo a campo ya no sale de aquí sino del paquete de la marca que
 * resuelva la edición (ver `normalizeUiConfig`).
 *
 * `colores` va vacío a propósito: la paleta de cada marca vive en `src/styles.css`
 * y sólo lo que la edición personalice se escribe en línea encima.
 */
export const DEFAULT_UI_CONFIG: UiConfig = {
  configVersion: 0,
  edicion: {
    codigo: 'consiglia',
    nombreProducto: CONSIGLIA.nombre,
  },
  branding: {
    marca: CONSIGLIA.id,
    logoUrl: CONSIGLIA.horizontal.color,
    logoDarkUrl: CONSIGLIA.horizontal.negativo,
    faviconUrl: CONSIGLIA.favicon,
    appIconUrl: CONSIGLIA.appIcon,
    colores: {},
    fuente: CONSIGLIA.fuente,
    tituloNavegador: CONSIGLIA.nombre,
  },
  features: {},
  textos: {},
};

/** Clave de localStorage donde se cachea el último payload aplicado. */
export const UI_CONFIG_STORAGE_KEY = 'ui-config';

/** Clave de localStorage del ETag asociado al payload cacheado. */
export const UI_CONFIG_ETAG_STORAGE_KEY = 'ui-config-etag';

/** Ruta pública (sin JWT) de la configuración de interfaz. */
export const UI_CONFIG_PATH = '/public/ui-config';

/** Tope de espera del primer fetch. Pasado esto la app arranca con lo que tenga. */
export const UI_CONFIG_FETCH_TIMEOUT_MS = 2000;
